import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=70e9e04a&scoped=true&"
import script from "./EmptyState.vue?vue&type=script&lang=ts&"
export * from "./EmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=70e9e04a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e9e04a",
  null
  
)

export default component.exports